'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeCharity = exports.searchCharities = exports.fetchCharity = exports.fetchCharities = exports.c = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var c = exports.c = {
  ENDPOINT: 'api/v2/charities',
  SEARCH_ENDPOINT: 'api/v2/search/charities'
};

var fetchCharities = exports.fetchCharities = function fetchCharities() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  var mappings = { campaign: 'campaign_ids' };
  var transforms = { campaign: function campaign(v) {
      return Array.isArray(v) ? v.join(',') : v;
    } };

  return (0, _client.get)(c.ENDPOINT, params, { mappings: mappings, transforms: transforms }).then(function (response) {
    return response.charities;
  });
};

var fetchCharity = exports.fetchCharity = function fetchCharity() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  if ((typeof id === 'undefined' ? 'undefined' : _typeof(id)) === 'object') {
    var _id$countryCode = id.countryCode,
        countryCode = _id$countryCode === undefined ? (0, _params.required)() : _id$countryCode,
        _id$slug = id.slug,
        slug = _id$slug === undefined ? (0, _params.required)() : _id$slug;


    return (0, _client.get)([c.ENDPOINT, countryCode, slug].join('/')).then(function (response) {
      return response.charity;
    });
  }

  return (0, _client.get)(c.ENDPOINT + '/' + id).then(function (response) {
    return response.charity;
  });
};

var searchCharities = exports.searchCharities = function searchCharities() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return (0, _client.get)(c.SEARCH_ENDPOINT, params).then(function (response) {
    return response.charities;
  });
};

var deserializeCharity = exports.deserializeCharity = function deserializeCharity(charity) {
  return {
    active: charity.active,
    campaigns: charity.campaign_uids,
    categories: charity.causes,
    country: charity.country_code,
    description: charity.description,
    donateUrl: charity.donate_url,
    getStartedUrl: charity.get_started_url,
    email: charity.public_email,
    id: charity.uid || charity.id,
    logo: charity.logo_url,
    name: charity.name,
    registrationNumber: charity.registration_number,
    slug: charity.slug,
    url: charity.url,
    uuid: charity.uuid
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/charities/everydayhero/index.js
// module id = 1403
// module chunks = 0